export default class PriceUtil {
  static convertStringToNumber(str: string = '') {
    const numberValue = parseFloat(str);
    if (!isNaN(numberValue)) {
      const multipliedValue = numberValue * 100;
      return Math.round(multipliedValue);
    } else {
      return 0;
    }
  }

  static convertNumberToString(number: number = 0) {
    if (!isNaN(number)) {
      const normalValue = number / 100;
      return `${Math.round(normalValue)}`;
    } else {
      return '-';
    }
  }
}
